import { type AuthUser } from 'wasp/auth';
import { FC, ReactNode, useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CommonLayout from '../../components/layout/CommonLayout';
import '../admin-theme.css';
import { adminLayoutConfig } from './adminConfig';
import { isAdministrator } from '../../client/lib/platformRole';

interface Props {
  user: AuthUser;
  children?: ReactNode;
}

const DefaultLayout: FC<Props> = ({ children, user }) => {
  const location = useLocation();
  
  if (!isAdministrator(user)) {
    return <Navigate to='/' replace />;
  }

  // Remove padding for admin pages that need full-width layout
  const shouldRemovePadding =
    location.pathname.startsWith('/admin/users') ||
    location.pathname.startsWith('/admin/organizations') ||
    location.pathname.startsWith('/admin/organization-types') ||
    location.pathname.startsWith('/admin/sections') ||
    location.pathname.startsWith('/admin/service-types') ||
    location.pathname.startsWith('/admin/service-definitions') ||
    location.pathname.startsWith('/admin/topic-types') ||
    location.pathname.startsWith('/admin/topics') ||
    location.pathname.startsWith('/admin/taxonomy/location-categories') ||
    location.pathname.startsWith('/admin/global-settings') ||
    location.pathname.startsWith('/admin/taxonomy/location-names') ||
    location.pathname.startsWith('/admin/canada') ||
    location.pathname.startsWith('/admin/feedback') ||
    location.pathname === '/admin/permissions' ||
    location.pathname === '/admin/approvals' ||
    location.pathname === '/admin/recycle-bin';

  const config = useMemo(() => adminLayoutConfig, []);

  return (
    <div className="admin-surface">
      <CommonLayout config={config}>
        <div className={`w-full ${shouldRemovePadding ? '' : 'px-6 py-4 md:px-8 md:py-6 2xl:px-10 2xl:py-8'}`}>{children}</div>
      </CommonLayout>
    </div>
  );
};

export default DefaultLayout;



